import { render, staticRenderFns } from "./GeneralSettingsDeliveryBlackouts.vue?vue&type=template&id=5706fa49&"
import script from "./GeneralSettingsDeliveryBlackouts.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsDeliveryBlackouts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports